import React from "react";
import { licenses, licenseDescriptionToLicense } from "../../reducers/download";

const toProperCase = function(s) {
    var arr = s.toLowerCase().split(" ");
    for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].substr(1);
    }
    return arr.join(" ");
};

const IconMicroData = ({ icon }) => {
    if (!icon) {
        return null;
    }
    let host = `${window.location.protocol}//${window.location.hostname}`;
    let permalink = `${host}${icon.permalink}`;

    if (permalink[permalink.length - 1] != "/") {
        permalink = `${permalink}/`;
    }

    let creator;
    if (icon.uploader) {
        let address;
        if (icon.uploader.location) {
            address = (
                <span
                    vocab="http://schema.org/"
                    typeof="PostalAddress"
                    property="address"
                >
                    <meta
                        property="addressCountry"
                        content={`${icon.uploader.location}`}
                    />
                </span>
            );
        }
        creator = (
            <span vocab="http://schema.org/" typeof="Person" property="author">
                <meta property="name" content={icon.uploader.name} />
                <meta
                    property="url"
                    content={`${host}${icon.uploader.permalink}`}
                />
                {address}
            </span>
        );
    }

    let description;
    if (icon.tags) {
        description = icon.tags
            .map(tag => tag.slug.split("-").join(" "))
            .join(", ");
        description = <meta property="description" content={description} />;
    }

    return (
        <div vocab="http://schema.org/" typeof="ImageObject">
            <meta property="url" content={permalink} />
            <meta property="contentUrl" content={icon.preview_url} />
            <meta
                property="license"
                content={
                    licenseDescriptionToLicense(icon.license_description) ==
                    licenses.PUBLIC_DOMAIN
                        ? "https://creativecommons.org/publicdomain/mark/1.0/"
                        : "https://creativecommons.org/licenses/by/3.0/"
                }
            />
            <meta property="name" content={`${toProperCase(icon.term)} Icon`} />
            {description}
            {creator}
        </div>
    );
};

export default IconMicroData;
